import { render } from "./TaskAddToComponent.vue?vue&type=template&id=6cb79508&scoped=true"
import script from "./TaskAddToComponent.vue?vue&type=script&lang=js"
export * from "./TaskAddToComponent.vue?vue&type=script&lang=js"

import "./TaskAddToComponent.vue?vue&type=style&index=0&id=6cb79508&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb79508"]])

export default __exports__